import List from '@zenbusiness/zui/List';
import { superstyled } from '@zenbusiness/zui/styles';

export const ListCard = superstyled({
  tag: List,
  name: 'BusinessOverview',
  slot: 'ListCard',
  styles: ({ theme }) => ({
    display: 'grid',
    gridTemplateColumns: 'repeat(1, 1fr)',
    gap: '1rem',

    [theme.breakpoints.up('sm')]: {
      gridTemplateColumns: 'repeat(2, 1fr)'
    },

    [theme.breakpoints.up('lg')]: {
      gap: '1.5rem',
      gridTemplateColumns: 'repeat(3, 1fr)'
    }
  })
});
